import {SagaIterator} from "redux-saga";
import {call, select, takeEvery, getContext} from "redux-saga/effects";
import {IceClient} from "@neolab/ice-client";

import {RootState} from "src/reducers";
import {logoutClicked} from "src/routes/Sidebar.actions";
import {loginFormSubmitted} from "src/routes/login/Login.actions";
import {retryConnectionClicked} from "../components/ConnectionBar.actions";


function credentialsSelector(state: RootState) {
  const {username, password, authProvider} = state.routes.login;

  return {username, password, domain: authProvider};
}

export default function* sessionSaga(): SagaIterator {
  const iceClient: IceClient = yield getContext('iceClient');

  yield takeEvery(logoutClicked.type, () => iceClient.logout());
  yield takeEvery(retryConnectionClicked.type,
    () => iceClient.retryConnection());

  yield takeEvery(loginFormSubmitted.type,
    function* loginFormWorker(): SagaIterator {
      const credentials = yield select(credentialsSelector);

      yield call(iceClient.login, credentials);
    },
  );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/session.ts